<template>
  <div>
    <div class="form-group" v-if="fieldMetadata.isDisplayed">
      <span v-if="fieldMetadata.inputType === 'Checkbox'">
        <br />
        <input
          type="Checkbox"
          :disabled="fieldMetadata.isDisabled"
          @change="
            $emit('change', {
              name: fieldMetadata.name,
              value: $event.target.checked
            })
          "
          :name="fieldMetadata.name"
          :id="fieldMetadata.name"
          :class="errorClass"
        />&nbsp; <b>{{ fieldMetadata.label }}</b>
      </span>
      <span v-else>
        <label :for="fieldMetadata.name">{{ fieldMetadata.label }}</label>
      </span>
      <span class="text-danger" v-if="fieldMetadata.isRequired">
        *
        <span class="sr-only">Required</span>
      </span>
      <select
        :value="dropDownValue"
        v-if="fieldMetadata.inputType === 'DropDownList'"
        :disabled="
          fieldMetadata.isDisabled || fieldMetadata.options.length == 1
        "
        @change="dropDownChange(fieldMetadata, $event)"
        class="form-control"
      >
        <option value>-- select an option --</option>
        <option
          v-for="item in fieldMetadata.options"
          :value="item.name"
          :key="item.name"
          >{{ item.label }}</option
        >
      </select>

      <input
        :value="value"
        type="text"
        class="form-control"
        v-if="
          fieldMetadata.inputType !== 'DropDownList' &&
            fieldMetadata.dataType !== 'Date' &&
            fieldMetadata.inputType !== 'Checkbox'
        "
        :disabled="fieldMetadata.isDisabled"
        @change="
          $emit('change', {
            name: fieldMetadata.name,
            value: $event.target.value
          })
        "
        :name="fieldMetadata.name"
        :id="fieldMetadata.name"
        :class="errorClass"
      />
      <datepicker
        v-if="fieldMetadata.dataType === 'Date'"
        :value="value"
        :disabled="fieldMetadata.isDisabled"
        @selected="
          $emit('change', {
            name: fieldMetadata.name,
            value: formatDate($event)
          })
        "
        :name="fieldMetadata.name"
        :id="fieldMetadata.name"
        :class="errorClass"
        :format="dateFormat"
        :bootstrap-styling="true"
        :typeable="true"
      ></datepicker>
      <span class="field-validation-error" v-if="this.error">{{ error }}</span>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import moment from "moment";

export default {
  components: {
    Datepicker
  },
  name: "Field",
  props: ["fieldMetadata", "value", "error"],
  created() {
    this.innerValue = this.value;
  },
  computed: {
    errorClass() {
      if (this.error) {
        return "input-validation-error";
      }
      return "";
    },
    dateFormat() {
      return "MM/dd/yyyy";
    },
    dropDownValue() {
      if (this.value) {
        return this.value;
      }
      if (
        this.fieldMetadata.options &&
        this.fieldMetadata.options.length == 1
      ) {
        this.updateValues(
          this.fieldMetadata.name,
          this.fieldMetadata.options[0].name,
          this.fieldMetadata.options[0].label
        );
        return this.fieldMetadata.options[0].name;
      }

      return "";
    }
  },
  methods: {
    dropDownChange(fieldMetadata, event) {
      let selectedValue = fieldMetadata.options.find(
        option => option.name === event.target.value
      );
      let displayValue = "";
      if (selectedValue) {
        displayValue = selectedValue.label;
      }
      this.updateValues(fieldMetadata.name, event.target.value, displayValue);
    },
    updateValues(fieldName, fieldValue, fieldDisplayValue) {
      this.$emit("change", {
        name: fieldName,
        value: fieldValue
      });
      this.$emit("change", {
        name: fieldName + "DisplayValue",
        value: fieldDisplayValue
      });
    },
    formatDate(date) {
      return moment(date).format("MM/DD/YYYY");
    }
  }
};
</script>
